var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEgypt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_33984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 0C6.84013 0 2.44161 3.2565 0.746094 7.82611H23.2534C21.5578 3.2565 17.1593 0 11.9997 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 24C17.1593 24 21.5578 20.7435 23.2533 16.1739H0.746094C2.44161 20.7435 6.84012 24 11.9997 24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.174 10.6956H13.0436C13.0436 10.1194 12.5764 9.65216 12.0001 9.65216C11.4238 9.65216 10.9566 10.1194 10.9566 10.6956H7.82617C7.82617 11.272 8.32816 11.7391 8.90444 11.7391H8.86966C8.86966 12.3155 9.33681 12.7826 9.91314 12.7826C9.91314 13.3589 10.3803 13.8261 10.9566 13.8261H13.0436C13.6199 13.8261 14.0871 13.3589 14.0871 12.7826C14.6634 12.7826 15.1306 12.3155 15.1306 11.7391H15.0958C15.6721 11.7391 16.174 11.272 16.174 10.6956Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_33984"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/92ac92af.svg";
export { SvgEgypt as ReactComponent };